import { Route, useActivePageRegistration } from "@hex-insights/router";
import { PageRouteSwitch } from "../../Components";
import { ReEnrollmentDataConsentPage } from "./DataConsentPage";
import { reEnrollmentDataConsentPageInfo } from "./DataConsentPage/pageinfo";
import { ReEnrollmentGuardiansPage } from "./GuardiansPage";
import { reEnrollmentGuardiansPageInfo } from "./GuardiansPage/pageinfo";
import { ReEnrollmentIndexPage } from "./IndexPage";
import { reEnrollmentIndexPageInfo } from "./IndexPage/pageinfo";
import { ReEnrollmentMealPlansPage } from "./MealPlansPage";
import { reEnrollmentMealPlansPageInfo } from "./MealPlansPage/pageinfo";
import { reEnrollmentPageInfo } from "./pageinfo";
import { ReEnrollmentPaymentPlansPage } from "./PaymentPlansPage";
import { reEnrollmentPaymentPlansPageInfo } from "./PaymentPlansPage/pageinfo";
import { ReEnrollmentReviewPage } from "./ReviewPage";
import { reEnrollmentReviewPageInfo } from "./ReviewPage/pageinfo";
import { ReEnrollmentStudentHealthPage } from "./StudentHealthPage";
import { reEnrollmentStudentHealthPageInfo } from "./StudentHealthPage/pageinfo";
import { ReEnrollmentSuccessPage } from "./SuccessPage";
import { reEnrollmentSuccessPageInfo } from "./SuccessPage/pageinfo";

export function ReEnrollmentPage() {
	useActivePageRegistration(reEnrollmentPageInfo);

	return (
		<PageRouteSwitch>
			<Route {...reEnrollmentIndexPageInfo}>
				<ReEnrollmentIndexPage />
			</Route>
			<Route {...reEnrollmentGuardiansPageInfo}>
				<ReEnrollmentGuardiansPage />
			</Route>
			<Route {...reEnrollmentStudentHealthPageInfo}>
				<ReEnrollmentStudentHealthPage />
			</Route>
			<Route {...reEnrollmentDataConsentPageInfo}>
				<ReEnrollmentDataConsentPage />
			</Route>
			<Route {...reEnrollmentMealPlansPageInfo}>
				<ReEnrollmentMealPlansPage />
			</Route>
			<Route {...reEnrollmentPaymentPlansPageInfo}>
				<ReEnrollmentPaymentPlansPage />
			</Route>
			<Route {...reEnrollmentReviewPageInfo}>
				<ReEnrollmentReviewPage />
			</Route>
			<Route {...reEnrollmentSuccessPageInfo}>
				<ReEnrollmentSuccessPage />
			</Route>
		</PageRouteSwitch>
	);
}
